/**
 * 体育类型枚举 - 基于运动名称
 */
export enum SportTypeMap {
  AIR_RACING = 'AIR_RACING',
  ALL = 'ALL',
  ALPINE_SKIING = 'ALPINE_SKIING',
  AMERICAN_FOOTBALL = 'AMERICAN_FOOTBALL',
  AQUATICS = 'AQUATICS',
  ARCHERY = 'ARCHERY',
  ARTISTIC_SWIMMING = 'ARTISTIC_SWIMMING',
  ATHLETICS = 'ATHLETICS',
  AUSSIE_RULES = 'AUSSIE_RULES',
  BADMINTON = 'BADMINTON',
  BANDY = 'BANDY',
  BASEBALL = 'BASEBALL',
  BASKETBALL = 'BASKETBALL',
  BASKETBALL_3X3 = 'BASKETBALL_3X3',
  BASQUE_PELOTA = 'BASQUE_PELOTA',
  BEACH_HANDBALL = 'BEACH_HANDBALL',
  BEACH_SOCCER = 'BEACH_SOCCER',
  BEACH_TENNIS = 'BEACH_TENNIS',
  BEACH_VOLLEY = 'BEACH_VOLLEY',
  BIATHLON = 'BIATHLON',
  BIKES = 'BIKES',
  BMX_RACING = 'BMX_RACING',
  BOBSLEIGH = 'BOBSLEIGH',
  BOWLS = 'BOWLS',
  BOXING = 'BOXING',
  BREAKING = 'BREAKING',
  CANOE_SLALOM = 'CANOE_SLALOM',
  CANOEING = 'CANOEING',
  CHESS = 'CHESS',
  CORNHOLE = 'CORNHOLE',
  CRICKET = 'CRICKET',
  CROSS_COUNTRY = 'CROSS_COUNTRY',
  CURLING = 'CURLING',
  CYCLING = 'CYCLING',
  CYCLING_BMX_FREESTYLE = 'CYCLING_BMX_FREESTYLE',
  CYCLING_BMX_RACING = 'CYCLING_BMX_RACING',
  CYCLING_CYCLE_BALL = 'CYCLING_CYCLE_BALL',
  CYCLO_CROSS = 'CYCLO_CROSS',
  DARTS = 'DARTS',
  DEPRECATED_SC = 'DEPRECATED_SC',
  DIVING = 'DIVING',
  DRAG_RACING = 'DRAG_RACING',
  DTM = 'DTM',
  EBASKETBALL = 'EBASKETBALL',
  ECRICKET = 'ECRICKET',
  EICE_HOCKEY = 'EICE_HOCKEY',
  ENDURANCE_RACING = 'ENDURANCE_RACING',
  EQUESTRIAN = 'EQUESTRIAN',
  ESOCCER = 'ESOCCER',
  ESPORT = 'ESPORT',
  ESPORT_APEX_LEGENDS = 'ESPORT_APEX_LEGENDS',
  ESPORT_ARENA_OF_VALOR = 'ESPORT_ARENA_OF_VALOR',
  ESPORT_ARTIFACT = 'ESPORT_ARTIFACT',
  ESPORT_AUTO_CHESS = 'ESPORT_AUTO_CHESS',
  ESPORT_BRAWL_STARS = 'ESPORT_BRAWL_STARS',
  ESPORT_CALL_OF_DUTY = 'ESPORT_CALL_OF_DUTY',
  ESPORT_CLASH_ROYALE = 'ESPORT_CLASH_ROYALE',
  ESPORT_COUNTER_STRIKE = 'ESPORT_COUNTER_STRIKE',
  ESPORT_CROSSFIRE = 'ESPORT_CROSSFIRE',
  ESPORT_DOTA = 'ESPORT_DOTA',
  ESPORT_DOTA_UNDERLORDS = 'ESPORT_DOTA_UNDERLORDS',
  ESPORT_DRAGON_BALL_FIGHTERZ = 'ESPORT_DRAGON_BALL_FIGHTERZ',
  ESPORT_FIGHTING_GAMES = 'ESPORT_FIGHTING_GAMES',
  ESPORT_FORTNITE = 'ESPORT_FORTNITE',
  ESPORT_GEARS_OF_WAR = 'ESPORT_GEARS_OF_WAR',
  ESPORT_HALO = 'ESPORT_HALO',
  ESPORT_HEARTHSTONE = 'ESPORT_HEARTHSTONE',
  ESPORT_HEROES_OF_THE_STORM = 'ESPORT_HEROES_OF_THE_STORM',
  ESPORT_KING_OF_GLORY = 'ESPORT_KING_OF_GLORY',
  ESPORT_LEAGUE_OF_LEGENDS = 'ESPORT_LEAGUE_OF_LEGENDS',
  ESPORT_MADDEN_NFL = 'ESPORT_MADDEN_NFL',
  ESPORT_MOTORSPORT = 'ESPORT_MOTORSPORT',
  ESPORT_MTG = 'ESPORT_MTG',
  ESPORT_OVERWATCH = 'ESPORT_OVERWATCH',
  ESPORT_PALADINS = 'ESPORT_PALADINS',
  ESPORT_PLAYERUNKNOWNS_BATTLEGROUNDS = 'ESPORT_PLAYERUNKNOWNS_BATTLEGROUNDS',
  ESPORT_PRO_EVOLUTION_SOCCER = 'ESPORT_PRO_EVOLUTION_SOCCER',
  ESPORT_QUAKE = 'ESPORT_QUAKE',
  ESPORT_RAINBOW_SIX = 'ESPORT_RAINBOW_SIX',
  ESPORT_ROCKET_LEAGUE = 'ESPORT_ROCKET_LEAGUE',
  ESPORT_SMITE = 'ESPORT_SMITE',
  ESPORT_SSBM = 'ESPORT_SSBM',
  ESPORT_STARCRAFT = 'ESPORT_STARCRAFT',
  ESPORT_STREET_FIGHTER_V = 'ESPORT_STREET_FIGHTER_V',
  ESPORT_TEAMFIGHT_TACTICS = 'ESPORT_TEAMFIGHT_TACTICS',
  ESPORT_TEKKEN = 'ESPORT_TEKKEN',
  ESPORT_TF2 = 'ESPORT_TF2',
  ESPORT_VAINGLORY = 'ESPORT_VAINGLORY',
  ESPORT_VALORANT = 'ESPORT_VALORANT',
  ESPORT_WARCRAFT_III = 'ESPORT_WARCRAFT_III',
  ESPORT_WILD_RIFT = 'ESPORT_WILD_RIFT',
  ESPORT_WORLD_OF_TANKS = 'ESPORT_WORLD_OF_TANKS',
  ESPORT_WORLD_OF_WARCRAFT = 'ESPORT_WORLD_OF_WARCRAFT',
  ETENNIS = 'ETENNIS',
  EVOLLEYBALL = 'EVOLLEYBALL',
  FENCING = 'FENCING',
  FIELD_HOCKEY = 'FIELD_HOCKEY',
  FIGURE_SKATING = 'FIGURE_SKATING',
  FINNISH_BASEBALL = 'FINNISH_BASEBALL',
  FISHING = 'FISHING',
  FLOORBALL = 'FLOORBALL',
  FORMULA_1 = 'FORMULA_1',
  FORMULA_2 = 'FORMULA_2',
  FORMULA_E = 'FORMULA_E',
  FREESTYLE = 'FREESTYLE',
  FREESTYLE_SKIING = 'FREESTYLE_SKIING',
  FUTSAL = 'FUTSAL',
  GAELIC_FOOTBALL = 'GAELIC_FOOTBALL',
  GAELIC_HURLING = 'GAELIC_HURLING',
  GAELIC_SPORTS = 'GAELIC_SPORTS',
  GOLF = 'GOLF',
  GREYHOUND = 'GREYHOUND',
  GYMNASTICS = 'GYMNASTICS',
  HANDBALL = 'HANDBALL',
  HORSE_RACING = 'HORSE_RACING',
  HORSEBALL = 'HORSEBALL',
  ICE_HOCKEY = 'ICE_HOCKEY',
  INDOOR_SOCCER = 'INDOOR_SOCCER',
  INDY_LIGHTS = 'INDY_LIGHTS',
  INDY_RACING = 'INDY_RACING',
  INLINE_HOCKEY = 'INLINE_HOCKEY',
  JUDO = 'JUDO',
  KABADDI = 'KABADDI',
  KARATE = 'KARATE',
  LACROSSE = 'LACROSSE',
  LUGE = 'LUGE',
  MARATHON_SWIMMING = 'MARATHON_SWIMMING',
  MMA = 'MMA',
  MODERN_PENTATHLON = 'MODERN_PENTATHLON',
  MODIFIED_RACING = 'MODIFIED_RACING',
  MOTO2 = 'MOTO2',
  MOTO3 = 'MOTO3',
  MOTOCROSS = 'MOTOCROSS',
  MOTOGP = 'MOTOGP',
  MOTORCYCLE_RACING = 'MOTORCYCLE_RACING',
  MOTORSPORT = 'MOTORSPORT',
  MOUNTAIN_BIKE = 'MOUNTAIN_BIKE',
  MUAY_THAI = 'MUAY_THAI',
  NASCAR_CAMPING_WORLD_TRUCK = 'NASCAR_CAMPING_WORLD_TRUCK',
  NASCAR_CUP_SERIES = 'NASCAR_CUP_SERIES',
  NASCAR_XFINITY_SERIES = 'NASCAR_XFINITY_SERIES',
  NETBALL = 'NETBALL',
  NHRA = 'NHRA',
  NORDIC_COMBINED = 'NORDIC_COMBINED',
  OFF_ROAD = 'OFF_ROAD',
  OLYMPICS = 'OLYMPICS',
  OLYMPICS_YOUTH = 'OLYMPICS_YOUTH',
  PADEL = 'PADEL',
  PESAPALLO = 'PESAPALLO',
  PETANQUE = 'PETANQUE',
  PICKLEBALL = 'PICKLEBALL',
  POLO = 'POLO',
  POOL = 'POOL',
  RACQUETBALL = 'RACQUETBALL',
  RALLY = 'RALLY',
  RHYTHMIC_GYMNASTICS = 'RHYTHMIC_GYMNASTICS',
  RIDING = 'RIDING',
  RINK_HOCKEY = 'RINK_HOCKEY',
  ROWING = 'ROWING',
  RUGBY = 'RUGBY',
  RUGBY_LEAGUE = 'RUGBY_LEAGUE',
  SAILING = 'SAILING',
  SCHWINGEN = 'SCHWINGEN',
  SEPAK_TAKRAW = 'SEPAK_TAKRAW',
  SEVENBALLRUN = '7BALLRUN',
  SHOOTING = 'SHOOTING',
  SHORT_TRACK = 'SHORT_TRACK',
  SKATEBOARDING = 'SKATEBOARDING',
  SKELETON = 'SKELETON',
  SKI_JUMPING = 'SKI_JUMPING',
  SKI_MOUNTAINEERING = 'SKI_MOUNTAINEERING',
  SNOOKER = 'SNOOKER',
  SNOWBOARD = 'SNOWBOARD',
  SNOWBOARDCROSS_PARALLEL = 'SNOWBOARDCROSS_PARALLEL',
  SOCCER = 'SOCCER',
  SOCCER_MYTHICAL = 'SOCCER_MYTHICAL',
  SOCCER_SPECIALS = 'SOCCER_SPECIALS',
  SOFTBALL = 'SOFTBALL',
  SPECIALS = 'SPECIALS',
  SPEED_BOAT_RACING = 'SPEED_BOAT_RACING',
  SPEED_SKATING = 'SPEED_SKATING',
  SPEEDWAY = 'SPEEDWAY',
  SPORT_CLIMBING = 'SPORT_CLIMBING',
  SPRINT_CAR_RACING = 'SPRINT_CAR_RACING',
  SQUASH = 'SQUASH',
  STOCK_CAR_RACING = 'STOCK_CAR_RACING',
  STREETHOCKEY = 'STREETHOCKEY',
  SUMO = 'SUMO',
  SUPERBIKE = 'SUPERBIKE',
  SURFING = 'SURFING',
  SWIMMING = 'SWIMMING',
  T_BASKET = 'T_BASKET',
  TABLE_TENNIS = 'TABLE_TENNIS',
  TAEKWONDO = 'TAEKWONDO',
  TENNIS = 'TENNIS',
  TOURING_CAR_RACING = 'TOURING_CAR_RACING',
  TRACK_CYCLING = 'TRACK_CYCLING',
  TRAMPOLINE_GYMNASTICS = 'TRAMPOLINE_GYMNASTICS',
  TRIATHLON = 'TRIATHLON',
  TROTTING = 'TROTTING',
  TRUCK_AND_TRACTOR_PULLING = 'TRUCK_AND_TRACTOR_PULLING',
  VOLLEYBALL = 'VOLLEYBALL',
  WATERPOLO = 'WATERPOLO',
  WEIGHTLIFTING = 'WEIGHTLIFTING',
  WINTER_SPORTS = 'WINTER_SPORTS',
  WORLD_CHAMPIONSHIP = 'WORLD_CHAMPIONSHIP',
  WORLD_LOTTERY = 'WORLD_LOTTERY',
  WRESTLING = 'WRESTLING',
}

/**
 * 运动ID映射枚举 - 将运动类型映射到对应的ID
 */
export enum SportIdMap {
  AIR_RACING = 'sr:sport:192',
  ALPINE_SKIING = 'sr:sport:43',
  AMERICAN_FOOTBALL = 'sr:sport:16',
  AQUATICS = 'sr:sport:74',
  ARCHERY = 'sr:sport:75',
  ARTISTIC_SWIMMING = 'sr:sport:95',
  ATHLETICS = 'sr:sport:36',
  AUSSIE_RULES = 'sr:sport:13',
  BADMINTON = 'sr:sport:31',
  BANDY = 'sr:sport:15',
  BASEBALL = 'sr:sport:3',
  BASKETBALL = 'sr:sport:2',
  BASKETBALL_3X3 = 'sr:sport:155',
  BASQUE_PELOTA = 'sr:sport:130',
  BEACH_HANDBALL = 'sr:sport:157',
  BEACH_SOCCER = 'sr:sport:60',
  BEACH_TENNIS = 'sr:sport:98',
  BEACH_VOLLEY = 'sr:sport:34',
  BIATHLON = 'sr:sport:44',
  BIKES = 'sr:sport:41',
  BMX_RACING = 'sr:sport:91',
  BOBSLEIGH = 'sr:sport:45',
  BOWLS = 'sr:sport:32',
  BOXING = 'sr:sport:10',
  BREAKING = 'sr:sport:204',
  CANOE_SLALOM = 'sr:sport:92',
  CANOEING = 'sr:sport:72',
  CHESS = 'sr:sport:33',
  CORNHOLE = 'sr:sport:205',
  CRICKET = 'sr:sport:21',
  CROSS_COUNTRY = 'sr:sport:46',
  CURLING = 'sr:sport:28',
  CYCLING = 'sr:sport:17',
  CYCLING_BMX_FREESTYLE = 'sr:sport:179',
  CYCLING_BMX_RACING = 'sr:sport:180',
  CYCLING_CYCLE_BALL = 'sr:sport:141',
  CYCLO_CROSS = 'sr:sport:207',
  DARTS = 'sr:sport:22',
  DEPRECATED_SC = 'sr:sport:177',
  DIVING = 'sr:sport:96',
  DRAG_RACING = 'sr:sport:147',
  DTM = 'sr:sport:42',
  EBASKETBALL = 'sr:sport:153',
  ECRICKET = 'sr:sport:197',
  EICE_HOCKEY = 'sr:sport:195',
  ENDURANCE_RACING = 'sr:sport:193',
  EQUESTRIAN = 'sr:sport:76',
  ESOCCER = 'sr:sport:137',
  ESPORT = 'sr:sport:107',
  ESPORT_APEX_LEGENDS = 'sr:sport:164',
  ESPORT_ARENA_OF_VALOR = 'sr:sport:158',
  ESPORT_ARTIFACT = 'sr:sport:162',
  ESPORT_AUTO_CHESS = 'sr:sport:175',
  ESPORT_BRAWL_STARS = 'sr:sport:168',
  ESPORT_CALL_OF_DUTY = 'sr:sport:118',
  ESPORT_CLASH_ROYALE = 'sr:sport:133',
  ESPORT_COUNTER_STRIKE = 'sr:sport:109',
  ESPORT_CROSSFIRE = 'sr:sport:123',
  ESPORT_DOTA = 'sr:sport:111',
  ESPORT_DOTA_UNDERLORDS = 'sr:sport:173',
  ESPORT_FIGHTING_GAMES = 'sr:sport:176',
  ESPORT_FORTNITE = 'sr:sport:170',
  ESPORT_GEARS_OF_WAR = 'sr:sport:132',
  ESPORT_HALO = 'sr:sport:124',
  ESPORT_HEARTHSTONE = 'sr:sport:113',
  ESPORT_HEROES_OF_THE_STORM = 'sr:sport:114',
  ESPORT_KING_OF_GLORY = 'sr:sport:134',
  ESPORT_LEAGUE_OF_LEGENDS = 'sr:sport:110',
  ESPORT_MADDEN_NFL = 'sr:sport:167',
  ESPORT_MOTORSPORT = 'sr:sport:178',
  ESPORT_MTG = 'sr:sport:171',
  ESPORT_OVERWATCH = 'sr:sport:121',
  ESPORT_PALADINS = 'sr:sport:161',
  ESPORT_PLAYERUNKNOWNS_BATTLEGROUNDS = 'sr:sport:140',
  ESPORT_PRO_EVOLUTION_SOCCER = 'sr:sport:166',
  ESPORT_QUAKE = 'sr:sport:139',
  ESPORT_RAINBOW_SIX = 'sr:sport:125',
  ESPORT_ROCKET_LEAGUE = 'sr:sport:128',
  ESPORT_SMITE = 'sr:sport:119',
  ESPORT_SSBM = 'sr:sport:160',
  ESPORT_STARCRAFT = 'sr:sport:112',
  ESPORT_STREET_FIGHTER_V = 'sr:sport:127',
  ESPORT_TEAMFIGHT_TACTICS = 'sr:sport:174',
  ESPORT_TEKKEN = 'sr:sport:156',
  ESPORT_TF2 = 'sr:sport:159',
  ESPORT_VAINGLORY = 'sr:sport:120',
  ESPORT_VALORANT = 'sr:sport:194',
  ESPORT_WARCRAFT_III = 'sr:sport:122',
  ESPORT_WILD_RIFT = 'sr:sport:199',
  ESPORT_WORLD_OF_TANKS = 'sr:sport:115',
  ESPORT_WORLD_OF_WARCRAFT = 'sr:sport:152',
  ETENNIS = 'sr:sport:196',
  EVOLLEYBALL = 'sr:sport:198',
  FENCING = 'sr:sport:77',
  FIELD_HOCKEY = 'sr:sport:24',
  FIGURE_SKATING = 'sr:sport:102',
  FINNISH_BASEBALL = 'sr:sport:53',
  FISHING = 'sr:sport:172',
  FLOORBALL = 'sr:sport:7',
  FORMULA_1 = 'sr:sport:40',
  FORMULA_2 = 'sr:sport:189',
  FORMULA_E = 'sr:sport:142',
  FREESTYLE = 'sr:sport:65',
  FREESTYLE_SKIING = 'sr:sport:103',
  FUTSAL = 'sr:sport:29',
  GAELIC_FOOTBALL = 'sr:sport:135',
  GAELIC_HURLING = 'sr:sport:136',
  GAELIC_SPORTS = 'sr:sport:27',
  GOLF = 'sr:sport:9',
  GREYHOUND = 'sr:sport:58',
  GYMNASTICS = 'sr:sport:78',
  HANDBALL = 'sr:sport:6',
  HORSE_RACING = 'sr:sport:55',
  HORSEBALL = 'sr:sport:73',
  ICE_HOCKEY = 'sr:sport:4',
  INDOOR_SOCCER = 'sr:sport:163',
  INDY_LIGHTS = 'sr:sport:165',
  INDY_RACING = 'sr:sport:129',
  INLINE_HOCKEY = 'sr:sport:57',
  JUDO = 'sr:sport:79',
  KABADDI = 'sr:sport:138',
  KARATE = 'sr:sport:181',
  LACROSSE = 'sr:sport:39',
  LUGE = 'sr:sport:51',
  MARATHON_SWIMMING = 'sr:sport:182',
  MMA = 'sr:sport:117',
  MODERN_PENTATHLON = 'sr:sport:80',
  MODIFIED_RACING = 'sr:sport:149',
  MOTO2 = 'sr:sport:68',
  MOTO3 = 'sr:sport:69',
  MOTOCROSS = 'sr:sport:144',
  MOTORCYCLE_RACING = 'sr:sport:190',
  MOTORSPORT = 'sr:sport:11',
  MOUNTAIN_BIKE = 'sr:sport:88',
  MUAY_THAI = 'sr:sport:202',
  NASCAR_CAMPING_WORLD_TRUCK = 'sr:sport:185',
  NASCAR_CUP_SERIES = 'sr:sport:70',
  NASCAR_XFINITY_SERIES = 'sr:sport:186',
  NETBALL = 'sr:sport:35',
  NHRA = 'sr:sport:187',
  NORDIC_COMBINED = 'sr:sport:47',
  OFF_ROAD = 'sr:sport:150',
  OLYMPICS = 'sr:sport:30',
  OLYMPICS_YOUTH = 'sr:sport:87',
  PADEL = 'sr:sport:71',
  PESAPALLO = 'sr:sport:61',
  PETANQUE = 'sr:sport:169',
  PICKLEBALL = 'sr:sport:206',
  POLO = 'sr:sport:116',
  POOL = 'sr:sport:25',
  RACQUETBALL = 'sr:sport:201',
  RALLY = 'sr:sport:101',
  RHYTHMIC_GYMNASTICS = 'sr:sport:93',
  RIDING = 'sr:sport:89',
  RINK_HOCKEY = 'sr:sport:38',
  ROWING = 'sr:sport:64',
  RUGBY = 'sr:sport:12',
  RUGBY_LEAGUE = 'sr:sport:59',
  SAILING = 'sr:sport:81',
  SCHWINGEN = 'sr:sport:56',
  SEPAK_TAKRAW = 'sr:sport:126',
  SEVENBALLRUN = 'sr:sport:143',
  SHOOTING = 'sr:sport:82',
  SHORT_TRACK = 'sr:sport:105',
  SKATEBOARDING = 'sr:sport:183',
  SKELETON = 'sr:sport:104',
  SKI_JUMPING = 'sr:sport:48',
  SKI_MOUNTAINEERING = 'sr:sport:208',
  SNOOKER = 'sr:sport:19',
  SNOWBOARD = 'sr:sport:49',
  SNOWBOARDCROSS_PARALLEL = 'sr:sport:66',
  SOCCER = 'sr:sport:1',
  SOCCER_MYTHICAL = 'sr:sport:106',
  SOCCER_SPECIALS = 'sr:sport:203',
  SOFTBALL = 'sr:sport:54',
  SPECIALS = 'sr:sport:18',
  SPEED_BOAT_RACING = 'sr:sport:146',
  SPEED_SKATING = 'sr:sport:50',
  SPEEDWAY = 'sr:sport:131',
  SPORT_CLIMBING = 'sr:sport:184',
  SPRINT_CAR_RACING = 'sr:sport:145',
  SQUASH = 'sr:sport:37',
  STOCK_CAR_RACING = 'sr:sport:191',
  STREETHOCKEY = 'sr:sport:62',
  SUMO = 'sr:sport:99',
  SUPERBIKE = 'sr:sport:100',
  SURFING = 'sr:sport:90',
  SWIMMING = 'sr:sport:52',
  T_BASKET = 'sr:sport:200',
  TABLE_TENNIS = 'sr:sport:20',
  TAEKWONDO = 'sr:sport:83',
  TENNIS = 'sr:sport:5',
  TOURING_CAR_RACING = 'sr:sport:188',
  TRACK_CYCLING = 'sr:sport:97',
  TRAMPOLINE_GYMNASTICS = 'sr:sport:94',
  TRIATHLON = 'sr:sport:84',
  TROTTING = 'sr:sport:8',
  TRUCK_AND_TRACTOR_PULLING = 'sr:sport:151',
  VOLLEYBALL = 'sr:sport:23',
  WATERPOLO = 'sr:sport:26',
  WEIGHTLIFTING = 'sr:sport:85',
  WINTER_SPORTS = 'sr:sport:14',
  WORLD_CHAMPIONSHIP = 'sr:sport:63',
  WORLD_LOTTERY = 'sr:sport:108',
  WRESTLING = 'sr:sport:86',
}

/**
 * 运动类型
 */
export type SportType = keyof typeof SportTypeMap;

/**
 * 支持直播数据sportradar组件的运动类目
 */
export const SUPPORT_LIVE_SPORTS: SportType[] = [
  SportTypeMap.SOCCER,
  SportTypeMap.BASKETBALL,
  SportTypeMap.ICE_HOCKEY,
  SportTypeMap.TENNIS,
  SportTypeMap.AMERICAN_FOOTBALL,
  SportTypeMap.HANDBALL,
  SportTypeMap.VOLLEYBALL,
  SportTypeMap.BEACH_VOLLEY,
  SportTypeMap.TABLE_TENNIS,
  SportTypeMap.BADMINTON,
  SportTypeMap.RUGBY,
  SportTypeMap.BASEBALL,
  SportTypeMap.CRICKET,
  SportTypeMap.DARTS,
  SportTypeMap.FUTSAL,
  SportTypeMap.SNOOKER,
  SportTypeMap.SQUASH,
  SportTypeMap.KABADDI,
  SportTypeMap.PADEL,
  SportTypeMap.ESOCCER,
  SportTypeMap.EBASKETBALL,
];

/**
 * 是否有直播icons的运动类目
 */
export const HAS_SPORT_ICON_ENUMS: SportType[] = [
  SportTypeMap.SOCCER,
  SportTypeMap.TENNIS,
  SportTypeMap.ICE_HOCKEY,
  SportTypeMap.BASKETBALL,
  SportTypeMap.HANDBALL,
  SportTypeMap.VOLLEYBALL,
  SportTypeMap.BASEBALL,
  SportTypeMap.FLOORBALL,
  SportTypeMap.GOLF,
  SportTypeMap.BOXING,
  SportTypeMap.RUGBY,
  SportTypeMap.AUSSIE_RULES,
  SportTypeMap.BANDY,
  SportTypeMap.AMERICAN_FOOTBALL,
  SportTypeMap.CYCLING,
  SportTypeMap.SNOOKER,
  SportTypeMap.TABLE_TENNIS,
  SportTypeMap.CRICKET,
  SportTypeMap.DARTS,
  SportTypeMap.FIELD_HOCKEY,
  SportTypeMap.WATERPOLO,
  SportTypeMap.CURLING,
  SportTypeMap.FUTSAL,
  SportTypeMap.BADMINTON,
  SportTypeMap.BOWLS,
  SportTypeMap.CHESS,
  SportTypeMap.BEACH_VOLLEY,
  SportTypeMap.SQUASH,
  SportTypeMap.RINK_HOCKEY,
  SportTypeMap.LACROSSE,
  SportTypeMap.FORMULA_1,
  SportTypeMap.SKI_JUMPING,
  SportTypeMap.BEACH_SOCCER,
  SportTypeMap.PESAPALLO,
  SportTypeMap.PADEL,
  SportTypeMap.RALLY,
  SportTypeMap.MMA,
  SportTypeMap.INDY_RACING,
  SportTypeMap.SPEEDWAY,
  SportTypeMap.GAELIC_FOOTBALL,
  SportTypeMap.GAELIC_HURLING,
  SportTypeMap.KABADDI,
  SportTypeMap.BASKETBALL_3X3,
  SportTypeMap.FORMULA_2,
  SportTypeMap.BEACH_HANDBALL,
  SportTypeMap.MOTORCYCLE_RACING,
  SportTypeMap.STOCK_CAR_RACING,
  SportTypeMap.SOCCER_SPECIALS,
  SportTypeMap.ESPORT_LEAGUE_OF_LEGENDS,
];

/**
 * 竞速比赛stage运动类目，没有主客队之分
 */
export const RACING_STAGE_SPORTS: SportType[] = [
  SportTypeMap.RALLY,
  SportTypeMap.INDY_RACING,
  SportTypeMap.FORMULA_E,
  SportTypeMap.DRAG_RACING,
  SportTypeMap.CYCLING,
  SportTypeMap.TOURING_CAR_RACING,
  SportTypeMap.FORMULA_2,
  SportTypeMap.MOTORCYCLE_RACING,
  SportTypeMap.STOCK_CAR_RACING,
  SportTypeMap.FORMULA_1,
  SportTypeMap.ALPINE_SKIING,
  SportTypeMap.BIATHLON,
  SportTypeMap.BOBSLEIGH,
  SportTypeMap.CROSS_COUNTRY,
  SportTypeMap.NORDIC_COMBINED,
  SportTypeMap.SKI_JUMPING,
  SportTypeMap.SNOWBOARD,
  SportTypeMap.SPEED_SKATING,
  SportTypeMap.LUGE,
  SportTypeMap.HORSE_RACING,
];

/**
 * 需要反转主客队显示位置的运动类目
 */
export const TEAM_INVERT_SPORTS: string[] = [SportIdMap.AMERICAN_FOOTBALL, SportIdMap.BASEBALL];

/**
 * 支持scoreboard组件的运动类目
 */
export const SUPPORT_SCOREBOARD: SportType[] = [
  SportTypeMap.SOCCER,
  SportTypeMap.BASKETBALL,
  SportTypeMap.ICE_HOCKEY,
  SportTypeMap.TENNIS,
  SportTypeMap.AMERICAN_FOOTBALL,
  SportTypeMap.HANDBALL,
  SportTypeMap.VOLLEYBALL,
  SportTypeMap.BEACH_VOLLEY,
  SportTypeMap.TABLE_TENNIS,
  SportTypeMap.BADMINTON,
  SportTypeMap.RUGBY,
  SportTypeMap.BASEBALL,
  SportTypeMap.DARTS,
  SportTypeMap.FUTSAL,
  SportTypeMap.SNOOKER,
  SportTypeMap.ESOCCER,
  SportTypeMap.EBASKETBALL,
];
